import {
  MagnifyingGlassIcon,
  ChevronUpDownIcon,
} from "@heroicons/react/24/outline";
import { Select, Option, Badge } from "@material-tailwind/react";
import AttachFileRoundedIcon from "@mui/icons-material/AttachFileRounded";
import React from "react";
import {
  UserPlusIcon,
  PencilIcon,
  TrashIcon,
  ArrowDownIcon,
} from "@heroicons/react/24/solid";
import {
  Dialog,
  Card,
  CardHeader,
  Input,
  Chip,
  Typography,
  Button,
  CardBody,
  CardFooter,
  IconButton,
  Tooltip,
} from "@material-tailwind/react";
import { useEffect, useState } from "react";
import {
  getPeopleData,
  createPeopleData,
  editPeopleData,
  getTrainingData,
  deletePeople,
  getDepartmentOption,
  assignTrainingInPeople,
  createPeopleThroughExcelUpload,
} from "../../helperFunctions/apiFunction";
import { useAuthUserToken } from "../../hooks/useAuthUserToken";
import TableSkeleton from "../../components/Loaders/TableSkeleton";
import toast from "react-hot-toast";
import LoadingButton from "../../components/Loaders/LoadingButton";
import ExcelJS from "exceljs";
import TrainingReactSelect from "./TrainingReactSelect";
import { AssignTraining, AssignEmpolyeeWise } from "./AssignTraining";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import * as XLSX from "xlsx";

const TABLE_HEAD = [
  "Name",
  "Department",
  "Designation",
  "Employement Status",
  "Compliance",
  "Trainings",
  "Action",
];

export default function PeopleManagement() {
  const { refreshToken, rbac } = useAuthUserToken();
  const [templateData, setTemplateData] = useState([]);
  const [trainingData, setTrainigData] = useState([]);
  const [peopleData, setPeopleData] = useState([]);
  const [isLoading, setIsLoading] = useState(null);
  const [searchBy, setSearchBy] = useState("");
  const [sortBy, setSortBy] = useState("asc");
  const [employementStatus, setEmployementStatus] = useState("");
  // const [compliantStatus, setCompliantStatus] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [errors, setErrors] = useState({ name: "" });
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [isLoadingSelectTraining, setIsLoadingSelectTraining] = useState(false);
  const [isLoadingSelectPeople, setIsLoadingSelectPeople] = useState(false);
  const [reloadData, setReloadData] = useState(false);
  const [assignDialog, setAssignDialog] = useState(false);
  const [selectOne, setSelectOne] = useState("");
  const navigate = useNavigate();
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [id, setId] = useState("");
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [uploadForm, setUploadForm] = useState({ file: null });
  const [excelData, setExcelData] = useState([]);
  const [excelError, setExcelError] = useState([]);
  const [isLoadingButtonForExcel, setIsLoadingButtonForExcel] = useState(false);
  const [excelLogEnteries, setExcelLogEnteries] = useState([]);
  const [assignTrainings, setAssignTrainings] = useState({
    scope: "",
    target: [],
    assignedTraining: [],
  });

  const requiredFields = [
    "employeeId",
    "employeeName",
    "employeeStatus",
    "employeeDepartment",
    "employeeDesignation",
    "employeeJoiningDate",
    "employeeLastDate",
    "assignedTraining",
  ];

  const [openCreateDialog, setOpenCreateDialog] = useState(false);

  const handleOpenCreateDialog = () => {
    setOpenCreateDialog((cur) => !cur);
  };

  useEffect(() => {
    setAssignTrainings({
      scope: selectOne,
      target: [],
      assignedTraining: [],
    });
  }, [selectOne]);

  const [open, setOpen] = useState(false);
  const handleOpen = (item) => {
    setFormData({
      employeeId: item?.employeeId || "",
      employeeName: item?.employeeName || "",
      employeeStatus: item?.employeeStatus || "",
      employeeDepartment: item?.employeeDepartment?.id || "",
      employeeDesignation: item?.employeeDesignation || "",
      employeeJoiningDate:
        moment(item?.employeeJoiningDate).format("YYYY-MM-DD") || "",
      employeeLastDate:
        moment(item?.employeeLastDate).format("YYYY-MM-DD") || "",
    });
    setId(item?.id || "");
    setErrors({ name: "" });
    setOpen((cur) => !cur);
  };

  useEffect(() => {
    setIsLoading(null);
    getPeopleData(
      refreshToken,
      searchBy,
      sortBy,
      limit,
      page,
      employementStatus,
      // compliantStatus
    ).then((data) => {
      if (data?.code === 403) {
        navigate('/403');
        toast.error(data?.message, {
          className: "text-[12px]",
        });
      }
      if (data?.code === 440)
        toast.error(data?.message, {
          className: "text-[12px]",
        });
      setTotalPage(data?.data?.totalPages);
      setTemplateData(data?.data?.results);
      setIsLoading(false);
    });
  }, [
    page,
    limit,
    sortBy,
    searchBy,
    employementStatus,
    // compliantStatus,
    reloadData,
  ]);

  useEffect(() => {
    getDepartmentOption(refreshToken).then((data) => {
      if (data?.code === 440)
        toast.error(data?.message, {
          className: "text-[12px]",
        });
      setDepartmentOptions(data?.data?.results);
      setIsLoading(false);
    });
  }, []);

  const handleDelete = (id) => {
    setIsLoadingButton(true);
    deletePeople(refreshToken, id)
      .then((response) => {
        if (response?.code === 200 || response?.code === 201) {
          toast.success("People Data deleted successfully", {
            className: "text-[12px]",
          });
        } else if (response.code === 400) {
          toast.error(response?.message, {
            className: "text-[12px]",
          });
        } else {
          toast.error(response?.message, {
            className: "text-[12px]",
          });
        }
      })
      .catch((error) => {
        toast.error("Something went wrong!", {
          className: "text-[12px]",
        });
        console.error("Error during login:", error);
      })
      .finally(() => {
        setIsLoading(null);
        setReloadData((cur) => !cur);
        setDeleteDialog((cur) => !cur);
        setIsLoadingButton(false);
        setId("");
      });
  };

  const handleDeleteDialog = (id) => {
    setId(id);
    setDeleteDialog((cur) => !cur);
  };

  // Create Form Functionality
  const [formData, setFormData] = useState({
    employeeId: "",
    employeeName: "",
    employeeStatus: "",
    employeeDepartment: "",
    employeeDesignation: "",
    employeeJoiningDate: "",
    employeeLastDate: "",
  });

  const validateForm = () => {
    const newErrors = {};
    if (!formData?.employeeId) newErrors.employeeId = "Employee Id is required";
    if (!formData.employeeName.trim())
      newErrors.employeeName = "Employee Name is required";
    if (!formData.employeeStatus.trim())
      newErrors.employeeStatus = "Employee Status is required";
    if (!formData.employeeDepartment)
      newErrors.employeeDepartment = "Employee Department is required";
    if (!formData.employeeDesignation.trim())
      newErrors.employeeDesignation = "Employee Designation is required";
    if (!formData.employeeJoiningDate.trim())
      newErrors.employeeJoiningDate = "Joining Date is required";
    if (
      Date.parse(formData.employeeJoiningDate) >=
      Date.parse(formData.employeeLastDate)
    ) {
      newErrors.employeeLastDate =
        "Last working date not be less than or equal to Joining Date";
    }
    setErrors(newErrors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleChangeSelect = (e, fieldName) => {
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: e,
    }));
  };

  const handleBlur = () => {
    validateForm();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    validateForm();

    if (Object.keys(errors).length === 0) {
      setIsLoadingButton(true);
      createPeopleData(refreshToken, formData)
        .then((response) => {
          if (response?.code === 200 || response?.code === 201) {
            toast.success("People Data created successfully", {
              className: "text-[12px]",
            });
          } else if (response.code === 400) {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          } else {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          }
        })
        .catch((error) => {
          toast.error("Something went wrong!", {
            className: "text-[12px]",
          });
          console.error("Error during login:", error);
        })
        .finally(() => {
          setIsLoadingButton(false);
          setFormData({
            employeeId: "",
            employeeName: "",
            employeeStatus: "",
            employeeDepartment: "",
            employeeDesignation: "",
            employeeJoiningDate: "",
            employeeLastDate: "",
          });
          setReloadData((cur) => !cur);
          setOpenCreateDialog((cur) => !cur);
        });
    }
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    validateForm();
    if (Object.keys(errors).length === 0) {
      setIsLoadingButton(true);
      editPeopleData(refreshToken, formData, id)
        .then((response) => {
          if (response?.code === 200 || response?.code === 201) {
            toast.success("People Data updated successfully", {
              className: "text-[12px]",
            });
          } else if (response.code === 400) {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          } else {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          }
        })
        .catch((error) => {
          toast.error("Something went wrong!", {
            className: "text-[12px]",
          });
          console.error("Error during login:", error);
        })
        .finally(() => {
          setFormData({
            employeeId: "",
            employeeName: "",
            employeeStatus: "",
            employeeDepartment: "",
            employeeDesignation: "",
            employeeJoiningDate: "",
            employeeLastDate: "",
          });
          setIsLoadingButton(false);
          setOpen((cur) => !cur);
          setReloadData((cur) => !cur);
        });
    }
  };
  // End Create Form Functionality

  const handleOpenAssignDialog = () => {
    setAssignDialog((cur) => !cur);
    setSelectOne("");
    setAssignTrainings({
      scope: "",
      target: [],
      assignedTraining: [],
    });
  };

  useEffect(() => {
    if (trainingData?.length === 0) {
      setIsLoadingSelectTraining(true);
      getTrainingData(refreshToken, "", "").then((data) => {
        if (data?.code === 440)
          toast.error(data?.message, {
            className: "text-[12px]",
          });
        setTrainigData(data?.data?.results);
        setIsLoadingSelectTraining(false);
      });
    }
    if (selectOne === "employee") {
      setIsLoadingSelectPeople(true);
      getPeopleData(refreshToken, "", "").then((resp) => {
        if (resp?.code === 440)
          toast.error(resp?.message, {
            className: "text-[12px]",
          });
        setPeopleData(resp?.data?.results);
        setIsLoadingSelectPeople(false);
      });
    }
  }, [setAssignDialog, selectOne]);

  const handleChangeSelect2 = (selectedOptions) => {
    let optionValues = [];

    if (selectedOptions?.length > 0) {
      if (selectOne === "department") {
        optionValues = selectedOptions.map((option) => option?.value);
      } else if (selectOne === "employee") {
        optionValues = selectedOptions.map((option) => option?.id);
      }
    }
    setAssignTrainings((prevState) => ({
      ...prevState,
      target: [...optionValues],
    }));
  };

  const handleChangeSelect3 = (selectedOptions) => {
    if (selectedOptions?.length > 0) {
      const optionValues = selectedOptions.map((option) => option?.id);
      setAssignTrainings((prevState) => ({
        ...prevState,
        assignedTraining: [...optionValues],
      }));
    }
  };

  const handelAssignTrainingToPeople = async (e) => {
    e.preventDefault();

    // Check the scope and handle the target field accordingly
    if (
      assignTrainings.scope === "all" ||
      (assignTrainings.scope?.length > 0 &&
        assignTrainings.assignedTraining?.length > 0 &&
        assignTrainings.target?.length > 0)
    ) {
      setIsLoadingButton(true);

      const modifiedAssignTrainings = { ...assignTrainings };

      // Remove the target field if the scope is "all"
      if (assignTrainings.scope === "all") {
        delete modifiedAssignTrainings.target;
      }

      assignTrainingInPeople(refreshToken, modifiedAssignTrainings)
        .then((response) => {
          if (response?.code === 200 || response?.code === 201) {
            toast.success(`Assign Training to ${selectOne} successfully`, {
              className: "text-[12px] capitalize",
            });
          } else if (response.code === 400) {
            toast.error(response?.message, {
              className: "text-[12px] capitalize",
            });
          } else {
            toast.error(response?.message, {
              className: "text-[12px] capitalize",
            });
          }
        })
        .catch((error) => {
          toast.error("Something went wrong!", {
            className: "text-[12px]",
          });
          console.error("Error during login:", error);
        })
        .finally(() => {
          setIsLoadingButton(false);
          setAssignDialog((cur) => !cur);
          setSelectOne("");
          setAssignTrainings({
            scope: "",
            target: [],
            assignedTraining: [],
          });
          setReloadData((cur) => !cur);
        });
    }
  };

  //excel upload functionality
  const handleOpenUploadDialog = () => {
    setOpenUploadDialog((cur) => !cur);
    setExcelData([]);
    setExcelError([]);
    setExcelLogEnteries([]);
    setUploadForm({ file: null });
    setIsLoadingButtonForExcel(false);
  };

  const validateUploadPeopleList = () => {
    const newErrors = {};
    if (!uploadForm.file) {
      newErrors.file = "File is required";
    }
    setErrors(newErrors);
    return newErrors;
  };

  const validateFields = (data) => {
    const newExcelErrors = [];
    const validatedData = data.map((item, index) => {
      const validatedItem = { ...item };
      requiredFields.forEach((field) => {
        if (!validatedItem[field] || validatedItem[field] === "") {
          if (validatedItem["employeeStatus"] === "employed") {
            console.error(
              `Row ${index + 1
              }: Field "${field}" is missing or empty in Excel file.`
            );
            newExcelErrors.push(
              `Row ${index + 1
              }: Field "${field}" is missing or empty in Excel file.`
            );
            validatedItem[field] = null;
          }
        }
      });

      if (
        validatedItem["assignedTraining"] &&
        typeof validatedItem["assignedTraining"] === "string"
      ) {
        validatedItem["assignedTraining"] = validatedItem["assignedTraining"]
          .split(",")
          .map((q) => q.trim());
      }

      const formatExcelDate = (excelDate) => {
        const date = moment(excelDate);
        if (date.isValid()) {
          return date.format("DD-MM-YYYY");
        } else {
          return null;
        }
      };

      if (validatedItem["employeeJoiningDate"]) {
        validatedItem["employeeJoiningDate"] = formatExcelDate(
          validatedItem["employeeJoiningDate"]
        );
      }
      if (validatedItem["employeeLastDate"]) {
        validatedItem["employeeLastDate"] = formatExcelDate(
          validatedItem["employeeLastDate"]
        );
      }

      return validatedItem;
    });
    setExcelError(newExcelErrors);
    return validatedData;
  };

  const handlePeopleFileUpload = async (event) => {
    const newErrors = {};
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        const validatedData = validateFields(jsonData);
        setExcelData(validatedData);
        setUploadForm({
          file: selectedFile,
        });
        newErrors.file = "";
      };
      reader.readAsArrayBuffer(selectedFile);
    } else {
      newErrors.file = "File is required";
    }
    setErrors(newErrors);
  };

  const handleUploadPeopleListSubmit = (e) => {
    e.preventDefault();
    const newErrors = validateUploadPeopleList();
    if (Object.keys(newErrors).length === 0 && excelError.length === 0) {
      setIsLoadingButtonForExcel(true);
      submitPeopleList();
    }
  };

  const submitPeopleList = () => {
    createPeopleThroughExcelUpload(refreshToken, excelData)
      .then((response) => {
        if (response?.code === 200 || response?.code === 201) {
          setExcelLogEnteries(response?.logEntries);
          toast.success("Vendors Data created successfully", {
            className: "text-[12px]",
          });
        } else if (response.code === 400) {
          toast.error(response?.message, {
            className: "text-[12px]",
          });
        } else {
          toast.error(response?.message, {
            className: "text-[12px]",
          });
        }
      })
      .catch((error) => {
        toast.error("Something went wrong!", {
          className: "text-[12px]",
        });
        console.error("Error during upload:", error);
      })
      .finally(() => {
        setOpenUploadDialog((cur) => !cur);
        setExcelData([]);
        setExcelError([]);
        setExcelLogEnteries([]);
        setUploadForm({ file: null });
        setIsLoadingButtonForExcel(false);
      });
  };

  // download excel
  const exportToExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("PeopleManagement Data");

    const headers = [
      "S.No.",
      "employeeId",
      "employeeName",
      "employeeStatus",
      "employeeDepartment",
      "employeeDesignation",
      "employeeJoiningDate",
      "employeeLastDate",
    ];

    worksheet.addRow(headers);

    templateData.forEach((row, index) => {
      const {
        employeeId,
        employeeName,
        employeeStatus,
        employeeDepartment,
        employeeDesignation,
        employeeJoiningDate,
        employeeLastDate,
        assignedTraining,
      } = row;
      worksheet.addRow([
        index + 1,
        employeeId,
        employeeName,
        employeeStatus,
        employeeDepartment?.departmentName,
        employeeDesignation,
        employeeJoiningDate,
        employeeLastDate,
        assignedTraining,
      ]);
    });

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "peopleManagement_data.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    });
  };

  // department excel
  const exportToExcelDepartment = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("PeopleManagement Data");

    const headers = ["S.No.", "Department Name"];

    worksheet.addRow(headers);

    departmentOptions.forEach((row, index) => {
      const { departmentName } = row;
      worksheet.addRow([index + 1, departmentName]);
    });

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "peopleManagement_Department_data.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    });
  };

  return (
    <div className="app-main__inner !pl-20">
      <Card
        className="h-full w-full rounded-3xl shadow-xl"
        style={{ backgroundImage: `url('/assets/images/beams.jpg')` }}
      >
        <CardHeader
          floated={false}
          shadow={false}
          className=" bg-transparent rounded-none !overflow-visible"
        >
          <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between md:gap-8">
            <div>
              <Typography variant="h5" color="blue-gray">
                List of Employees
              </Typography>
              <Typography color="gray" className="mt-1 font-normal">
                View all employees and compliance of assigned trainings
              </Typography>
            </div>
            <div className="flex flex-row flex-wrap md:flex-row items-center justify-between md:items-center gap-2 md:gap-8 mt-4 md:mt-0">
              <Button
                variant="outlined"
                size="sm"
                onClick={exportToExcel}
                loading={isLoading === null ? true : false}
              >
                <ArrowDownIcon strokeWidth={2} className="h-4 w-4" />
              </Button>
              <Button
                size="sm"
                onClick={handleOpenAssignDialog}
                loading={isLoading === null ? true : false}
                type="button"
              >
                Assign
              </Button>
              {rbac?.peopleAdd ? (
                <>
                  <Tooltip
                    className="bg-blue-gray-500"
                    content="Upload people's list"
                  >
                    <Button
                      onClick={handleOpenUploadDialog}
                      className="flex items-center gap-3"
                      loading={isLoading === null ? true : false}
                      size="sm"
                    >
                      Upload
                    </Button>
                  </Tooltip>
                  <Button
                    onClick={handleOpenCreateDialog}
                    className="flex items-center gap-3"
                    loading={isLoading === null ? true : false}
                    size="sm"
                  >
                    <UserPlusIcon strokeWidth={2} className="h-4 w-4" />{" "}
                    <span className="hidden md:inline-block"> Create New</span>
                  </Button>
                </>
              ) : null}
            </div>
          </div>
          <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full">
              <Select
                color="blue"
                label="Select Limit"
                className="!border-t-0 !border-[#b0bec5]"
                onChange={(event) => {
                  setLimit(event);
                  setIsLoading(null);
                }}
                value={limit}
              >
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={30}>30</Option>
                <Option value={40}>40</Option>
                <Option value={50}>50</Option>
              </Select>
              <Select
                color="purple"
                label="Sort By"
                className="!border-t-0 !border-[#b0bec5]"
                value={sortBy}
                onChange={(event) => {
                  setSortBy(event);
                  setIsLoading(null);
                }}
              >
                <Option value="asc">Ascending</Option>
                <Option value="desc">Descending</Option>
              </Select>
              {/* <Select
                color="green"
                label="Compliant Status"
                value={compliantStatus}
                className="!border-t-0 !border-[#b0bec5]"
                onChange={(event) => {
                  setCompliantStatus(event);
                  setIsLoading(null);
                }}
              >
                <Option value="">All Data</Option>
                <Option value="compliant">Compliant</Option>
                <Option value="nonCompliant">Non Compliant</Option>
              </Select> */}
              <Select
                color="green"
                label="Employment Status"
                value={employementStatus}
                className="!border-t-0 !border-[#b0bec5]"
                onChange={(event) => {
                  setEmployementStatus(event);
                  setIsLoading(null);
                }}
              >
                <Option value="">All Data</Option>
                <Option value="employed">Employed</Option>
                <Option value="resigned">Resigned</Option>
              </Select>
            </div>
            <div className="w-full md:w-auto sm:mt-2 xs:mt-2">
              <Input
                label="Search"
                value={searchBy}
                className="focus:!border-black focus:!border-2 focus:!border-t-0"
                onChange={(e) => setSearchBy(e.target.value)}
                icon={<MagnifyingGlassIcon className="h-5 w-5" />}
              />
            </div>
          </div>
        </CardHeader>
        <CardBody className="overflow-scroll px-3 p-0">
          <table className="mt-4 w-full min-w-max table-auto text-left">
            <thead>
              <tr>
                {TABLE_HEAD.map((head, index) => (
                  <th
                    key={head}
                    className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-3 transition-colors hover:bg-blue-gray-50"
                  >
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                    >
                      {head}{" "}
                      {index !== TABLE_HEAD?.length - 1 && (
                        <ChevronUpDownIcon
                          strokeWidth={2}
                          className="h-4 w-4"
                        />
                      )}
                    </Typography>
                  </th>
                ))}
              </tr>
            </thead>
            {isLoading === null ? (
              <>
                <tbody>
                  <tr>
                    <td colSpan={TABLE_HEAD.length}>
                      <TableSkeleton />
                    </td>
                  </tr>
                </tbody>
              </>
            ) : (
              <>
                <tbody>
                  {isLoading === false && templateData?.length > 0 ? (
                    templateData.map((item, index) => {
                      if (!item) return null;
                      const {
                        employeeId,
                        employeeName,
                        employeeStatus,
                        employeeDepartment,
                        employeeDesignation,
                        employeeJoiningDate,
                        assignedTraining,
                        employeeLastDate,
                        id,
                      } = item;
                      const isLast = index === templateData?.length - 1;
                      const classes = isLast
                        ? "p-4"
                        : "p-4 border-b border-blue-gray-50";
                      const isCompliant = () => {
                        return !assignedTraining.some(
                          (item) => item.status === "pending"
                        );
                      };
                      const trainingStatus =
                        assignedTraining && assignedTraining?.length === 0
                          ? "Compliant"
                          : isCompliant()
                            ? "Compliant"
                            : "Non-Compliant";

                      const trainingColor =
                        trainingStatus === "Compliant" ? "green" : "red";
                      let pendingCount = 0;
                      if (assignedTraining && assignedTraining?.length > 0) {
                        assignedTraining.forEach((item) => {
                          if (item.status === "pending") {
                            pendingCount++;
                          }
                        });
                      }
                      return (
                        <tr key={`${id}-${index}`}>
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                            >
                              {employeeName}
                            </Typography>
                          </td>
                          <td className={`${classes}`}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                            >
                              {employeeDepartment?.departmentName}
                            </Typography>
                          </td>
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                            >
                              {employeeDesignation}
                            </Typography>
                          </td>
                          <td className={classes}>
                            <div className="w-max">
                              <Chip
                                variant="ghost"
                                size="sm"
                                value={employeeStatus}
                                color={
                                  employeeStatus === "employed"
                                    ? "green"
                                    : "red"
                                }
                              />
                            </div>
                          </td>
                          <td className={classes}>
                            <div className="w-max">
                              <Chip
                                variant="ghost"
                                size="sm"
                                value={trainingStatus}
                                color={trainingColor}
                              />
                            </div>
                          </td>
                          <td className={classes}>
                            <Badge
                              className="text-center"
                              color={pendingCount > 0 ? "red" : "green"}
                              content={
                                pendingCount > 0 ? (
                                  pendingCount
                                ) : (
                                  <span className="text-center">O</span>
                                )
                              }
                              withBorder
                            >
                              <Tooltip
                                className="bg-blue-gray-500"
                                content="Assigned Training"
                                placement="top"
                              >
                                <Link
                                  to={`/peopleManagement/trainings/${id}`}
                                >
                                  <Button
                                    variant="gradient"
                                    size="sm"
                                    className="no-underline"
                                  >
                                    View Trainings
                                  </Button>
                                </Link>
                              </Tooltip>
                            </Badge>
                          </td>

                          <td className={classes}>
                            <div className="flex gap-1.5">
                              {rbac?.peopleEdit || rbac?.peopleDel ? (
                                <>
                                  {rbac?.peopleEdit && (
                                    <Tooltip className="bg-blue-gray-500" content="Edit">
                                      <IconButton
                                        variant="text"
                                        onClick={() =>
                                          handleOpen({
                                            employeeId,
                                            employeeName,
                                            employeeStatus,
                                            employeeDepartment,
                                            employeeDesignation,
                                            employeeJoiningDate,
                                            employeeLastDate,
                                            id,
                                          })
                                        }
                                      >
                                        <PencilIcon className="h-4 w-4" />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                  {rbac?.peopleDel && (
                                    <Tooltip className="bg-blue-gray-500" content="Delete Record">
                                      <IconButton variant="text" onClick={() => handleDeleteDialog(id)}>
                                        <TrashIcon className="h-4 w-4" />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </>
                              ) : (
                                <td></td>
                              )}

                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="8">
                        <div className="flex flex-col items-center w-full">
                          <img
                            quality={100}
                            src="/assets/images/9276430.jpg"
                            className="w-[350px] mix-blend-darken"
                            alt="no-data-found"
                          />
                          <p className="text-[20px] font-medium">
                            No Data Found!
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </>
            )}
          </table>
        </CardBody>
        {isLoading === null ? null : (
          <>
            <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
              <Button
                variant="outlined"
                size="sm"
                onClick={() => {
                  setPage(page - 1);
                  setIsLoading(null);
                }}
                disabled={totalPage > 1 ? false : true}
              >
                Previous
              </Button>
              <div className="flex items-center gap-2">
                {Array.from({ length: totalPage }, (_, index) => (
                  <IconButton
                    key={index + 1}
                    variant={index + 1 === page ? "outlined" : "text"}
                    size="sm"
                    onClick={() => {
                      setIsLoading(null);
                      setPage(index + 1);
                    }}
                    disabled={totalPage > 1 ? false : true}
                  >
                    {index + 1}
                  </IconButton>
                ))
                  .reduce((acc, button, index, array) => {
                    if (
                      index < 3 ||
                      index >= totalPage - 3 ||
                      (index >= Math.max(page - 1, 3) &&
                        index <= Math.min(page + 1, totalPage - 4))
                    ) {
                      acc.push(button);
                    } else if (acc[acc.length - 1] !== "ellipsis") {
                      acc.push("ellipsis");
                    }
                    return acc;
                  }, [])
                  .map((element, index, array) => {
                    return element === "ellipsis" ? (
                      <IconButton
                        key={`ellipsis-${index}`}
                        variant="text"
                        size="sm"
                        disabled
                      >
                        ...
                      </IconButton>
                    ) : index > 0 && array[index - 1] === "ellipsis" ? (
                      <React.Fragment key={`fragment-${index}`}>
                        {element}
                      </React.Fragment>
                    ) : (
                      element
                    );
                  })}
              </div>

              <Button
                variant="outlined"
                size="sm"
                onClick={() => {
                  setPage(page + 1);
                  setIsLoading(null);
                }}
                disabled={totalPage > 1 ? false : true}
              >
                Next
              </Button>
            </CardFooter>
          </>
        )}
      </Card>

      {/* Edit People */}
      <Dialog
        size="lg"
        open={open}
        handler={handleOpen}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <form onSubmit={handleEdit}>
          <Card className="mx-auto w-full">
            <CardBody className="flex flex-col gap-4">
              <Typography variant="h4" color="blue-gray">
                Edit | People Management
              </Typography>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Typography className="mb-1 " variant="h6">
                    Employee ID
                  </Typography>
                  <Input
                    type="text"
                    label="Employee ID"
                    size="lg"
                    name="employeeId"
                    value={formData?.employeeId}
                    disabled={true}
                    className="focus:!border-2 focus:!border-t-0 focus:!border-black cursor-not-allowed"
                  />
                  {errors.employeeId && (
                    <p className="text-red-900 text-[12px]">
                      {errors.employeeId}
                    </p>
                  )}
                </div>

                <div>
                  <Typography className="mb-1 " variant="h6">
                    Name
                  </Typography>
                  <Input
                    type="text"
                    label="Name"
                    size="lg"
                    name="employeeName"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={formData?.employeeName}
                    className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  />
                  {errors.employeeName && (
                    <p className="text-red-900 text-[12px]">
                      {errors.employeeName}
                    </p>
                  )}
                </div>

                <div>
                  <Typography className="mb-1 " variant="h6">
                    Employment Status
                  </Typography>
                  <Select
                    label="Status"
                    name="employeeStatus"
                    onChange={(e) => handleChangeSelect(e, "employeeStatus")}
                    onBlur={handleBlur}
                    color="purple"
                    value={formData?.employeeStatus || ""}
                  >
                    <Option value="">Select Status</Option>
                    <Option value="employed">Employed</Option>
                    <Option value="resigned">Resigned</Option>
                  </Select>
                  {errors.employeeStatus && (
                    <p className="text-red-900 text-[12px]">
                      {errors.employeeStatus}
                    </p>
                  )}
                </div>

                <div>
                  <Typography className="mb-1" variant="h6">
                    Department
                  </Typography>
                  <Select
                    label="Department"
                    name="employeeDepartment"
                    onChange={(e) =>
                      handleChangeSelect(e, "employeeDepartment")
                    }
                    onBlur={handleBlur}
                    color="purple"
                    value={formData?.employeeDepartment || ""}
                  >
                    {departmentOptions && departmentOptions.length > 0 ? (
                      departmentOptions.map((department) => (
                        <Option key={department.id} value={department.id}>
                          {department.departmentName}
                        </Option>
                      ))
                    ) : (
                      <Option disabled>No departments available</Option>
                    )}
                  </Select>
                  {errors.employeeDepartment && (
                    <p className="text-red-900 text-[12px]">
                      {errors.employeeDepartment}
                    </p>
                  )}
                </div>

                <div>
                  <Typography className="mb-1 " variant="h6">
                    Designation
                  </Typography>
                  <Input
                    type="text"
                    name="employeeDesignation"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Designation"
                    size="lg"
                    value={formData?.employeeDesignation}
                    className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  />
                  {errors.employeeDesignation && (
                    <p className="text-red-900 text-[12px]">
                      {errors.employeeDesignation}
                    </p>
                  )}
                </div>

                <div>
                  <Typography className="mb-1 " variant="h6">
                    Joining Date
                  </Typography>
                  <Input
                    type="date"
                    label="Start Date"
                    size="lg"
                    name="employeeJoiningDate"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={formData?.employeeJoiningDate}
                    className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  />
                  {errors.employeeJoiningDate && (
                    <p className="text-red-900 text-[12px]">
                      {errors.employeeJoiningDate}
                    </p>
                  )}
                </div>

                <div>
                  <Typography className="mb-1 " variant="h6">
                    Last working Date
                  </Typography>
                  <Input
                    type="date"
                    label="Last working Date"
                    size="lg"
                    name="employeeLastDate"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={formData?.employeeLastDate}
                    className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  />
                  {errors.employeeLastDate && (
                    <p className="text-red-900 text-[12px]">
                      {errors.employeeLastDate}
                    </p>
                  )}
                </div>
              </div>
            </CardBody>
            <CardFooter className="flex justify-end border-t-2 py-2">
              <Button
                variant="text"
                color="red"
                onClick={handleOpen}
                className="mr-1"
              >
                <span>Cancel</span>
              </Button>
              {isLoadingButton ? (
                <>
                  <LoadingButton isSetText={true} isLoading={isLoading} />
                </>
              ) : (
                <Button
                  variant="gradient"
                  color="green"
                  type="submit"
                // onClick={handleOpenCreateDialog}
                >
                  <span>Update</span>
                </Button>
              )}
            </CardFooter>
          </Card>
        </form>
      </Dialog>

      {/* create new */}
      <Dialog
        size="lg"
        open={openCreateDialog}
        handler={() => setOpenCreateDialog(false)}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <form onSubmit={handleSubmit}>
          <Card className="mx-auto w-full">
            <CardBody className="flex flex-col gap-4">
              <Typography variant="h4" color="blue-gray">
                Add | People Management
              </Typography>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Typography className="mb-1 " variant="h6">
                    Employee ID
                  </Typography>
                  <Input
                    type="text"
                    label="Employee ID"
                    size="lg"
                    name="employeeId"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // value={selectedItem?.integrationProvider}
                    className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  />
                  {errors.employeeId && (
                    <p className="text-red-900 text-[12px]">
                      {errors.employeeId}
                    </p>
                  )}
                </div>

                <div>
                  <Typography className="mb-1 " variant="h6">
                    Employee Name
                  </Typography>
                  <Input
                    type="text"
                    label="Employee Name"
                    size="lg"
                    name="employeeName"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // value={selectedItem?.integrationProvider}
                    className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  />
                  {errors.employeeName && (
                    <p className="text-red-900 text-[12px]">
                      {errors.employeeName}
                    </p>
                  )}
                </div>

                <div>
                  <Typography className="mb-1 " variant="h6">
                    Employee Status
                  </Typography>
                  <Select
                    label="Status"
                    name="employeeStatus"
                    onChange={(e) => handleChangeSelect(e, "employeeStatus")}
                    onBlur={handleBlur}
                    color="purple"
                  >
                    <Option value="active">Select Status</Option>
                    <Option value="employed">Employed</Option>
                    <Option value="resigned">Resigned</Option>
                  </Select>
                  {errors.employeeStatus && (
                    <p className="text-red-900 text-[12px]">
                      {errors.employeeStatus}
                    </p>
                  )}
                </div>

                <div>
                  <Typography className="mb-1" variant="h6">
                    Employee Department
                  </Typography>
                  <Select
                    label="Department"
                    name="employeeDepartment"
                    onChange={(e) =>
                      handleChangeSelect(e, "employeeDepartment")
                    }
                    onBlur={handleBlur}
                    color="purple"
                  >
                    {departmentOptions && departmentOptions.length > 0 ? (
                      departmentOptions.map((department) => (
                        <Option key={department.id} value={department.id}>
                          {department.departmentName}
                        </Option>
                      ))
                    ) : (
                      <Option disabled>No departments available</Option>
                    )}
                  </Select>
                  {errors.employeeDepartment && (
                    <p className="text-red-900 text-[12px]">
                      {errors.employeeDepartment}
                    </p>
                  )}
                </div>

                <div>
                  <Typography className="mb-1" variant="h6">
                    Designation
                  </Typography>
                  <Input
                    type="text"
                    name="employeeDesignation"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Designation"
                    size="lg"
                    // value={selectedItem?.integrationConfig[0]?.accountId}
                    className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  />
                  {errors.employeeDesignation && (
                    <p className="text-red-900 text-[12px]">
                      {errors.employeeDesignation}
                    </p>
                  )}
                </div>

                <div>
                  <Typography className="mb-1 " variant="h6">
                    Joining Date
                  </Typography>
                  <Input
                    type="date"
                    label="Start Date"
                    size="lg"
                    name="employeeJoiningDate"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // value={selectedItem?.integrationConfig[0]?.subscriptionId}
                    className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  />
                  {errors.employeeJoiningDate && (
                    <p className="text-red-900 text-[12px]">
                      {errors.employeeJoiningDate}
                    </p>
                  )}
                </div>

                <div>
                  <Typography className="mb-1" variant="h6">
                    Last Working Date
                  </Typography>
                  <Input
                    type="date"
                    label="Completion Date"
                    size="lg"
                    name="employeeLastDate"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // value={selectedItem?.integrationConfig[0]?.project}
                    className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  />
                  {errors.employeeLastDate && (
                    <p className="text-red-900 text-[12px]">
                      {errors.employeeLastDate}
                    </p>
                  )}
                </div>
              </div>
            </CardBody>
            <CardFooter className="flex justify-end border-t-2 py-2">
              <Button
                variant="text"
                color="red"
                onClick={handleOpenCreateDialog}
                className="mr-1"
              >
                <span>Cancel</span>
              </Button>
              {isLoadingButton ? (
                <>
                  <LoadingButton isSetText={true} isLoading={isLoading} />
                </>
              ) : (
                <Button variant="gradient" type="submit" color="green">
                  <span>Create</span>
                </Button>
              )}
            </CardFooter>
          </Card>
        </form>
      </Dialog>

      {/* delete people data */}
      <Dialog
        size="sm"
        open={deleteDialog}
        handler={setDeleteDialog}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <Card className="mx-auto w-full p-2">
          <CardBody className="flex flex-col gap-4">
            <Typography variant="h6" color="blue-gray">
              Are you sure you want to delete?
            </Typography>
          </CardBody>
          <CardFooter className="flex justify-end py-2">
            <Button
              variant="text"
              color="red"
              onClick={() => {
                setId("");
                setDeleteDialog(false);
              }}
              className="mr-1"
            >
              <span>Cancel</span>
            </Button>
            {isLoadingButton ? (
              <>
                <LoadingButton isSetText={true} isLoading={isLoading} />
              </>
            ) : (
              <Button
                variant="gradient"
                type="submit"
                color="green"
                loading={isLoadingButton}
                onClick={() => handleDelete(id, "peopledata")}
              >
                <span>Delete</span>
              </Button>
            )}
          </CardFooter>
        </Card>
      </Dialog>

      {/* Assign */}
      <Dialog
        size="lg"
        open={assignDialog}
        handler={() => setAssignDialog(false)}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <form onSubmit={handelAssignTrainingToPeople}>
          <Card className="mx-auto w-full">
            <CardBody className="flex flex-col gap-4">
              <Typography variant="h4" color="blue-gray">
                Assign | Training
              </Typography>
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <Select
                    color="green"
                    label="Scope"
                    value={selectOne}
                    className="!border-t-0 !border-[#b0bec5]"
                    onChange={(event) => {
                      setSelectOne(event);
                    }}
                  >
                    <Option value="">Select Scope</Option>
                    <Option value="all">Assign to All</Option>
                    <Option value="department">Assign to Department</Option>
                    <Option value="employee">Assign to Employee</Option>
                  </Select>
                </div>
                <div>
                  {selectOne === "department" && (
                    <AssignTraining
                      key="department"
                      assignData={[...departmentOptions]}
                      disable={selectOne === "" || selectOne === "all"}
                      handleChange={handleChangeSelect2}
                    />
                  )}

                  {selectOne === "employee" && (
                    <AssignEmpolyeeWise
                      key="employee"
                      assignData={peopleData}
                      isLoadingSelect={isLoadingSelectPeople}
                      disable={selectOne === "" || selectOne === "all"}
                      handleChange={handleChangeSelect2}
                    />
                  )}

                  {selectOne !== "department" && selectOne !== "employee" && (
                    <Select
                      key="default"
                      color="green"
                      className="focus:!border-black focus:!border-2 focus:!border-t-0 bg-gray-300"
                      disabled
                    >
                      <Option value="">Select Data</Option>
                    </Select>
                  )}
                </div>

                <div>
                  <TrainingReactSelect
                    trainingDataList={trainingData}
                    isLoadingSelect={isLoadingSelectTraining}
                    handleChange={handleChangeSelect3}
                    disable={selectOne === "" ? true : false}
                  />
                </div>
              </div>
            </CardBody>
            <CardFooter className="flex justify-end border-t-2 py-2">
              <Button
                variant="text"
                color="red"
                onClick={handleOpenAssignDialog}
                className="mr-1"
              >
                <span>Cancel</span>
              </Button>
              {isLoadingButton ? (
                <>
                  <LoadingButton isSetText={true} isLoading={isLoading} />
                </>
              ) : (
                <Button variant="gradient" type="submit" color="green">
                  <span>Assign</span>
                </Button>
              )}
            </CardFooter>
          </Card>
        </form>
      </Dialog>

      {/*Excel upload People Modal */}
      <Dialog
        size="md"
        open={openUploadDialog}
        handler={setOpenUploadDialog}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <form onSubmit={handleUploadPeopleListSubmit}>
          <Card className="mx-auto w-full p-2">
            {excelLogEnteries.length === 0 ? (
              <>
                <CardBody className="overflow-y-auto flex flex-col gap-4 max-h-[calc(100vh-150px)]">
                  <Typography variant="h4" color="blue-gray">
                    Upload People list
                  </Typography>
                  <div className="grid grid-cols-1">
                    <input
                      className="block p-2 w-full h-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none"
                      id="file_input"
                      onChange={handlePeopleFileUpload}
                      accept=".csv, .xlsx, .xls, .xlsm, .xlsb"
                      name="file"
                      type="file"
                    />
                    {errors.file && (
                      <p className="text-red-900 text-[12px]">{errors.file}</p>
                    )}
                    {excelError.length > 0 &&
                      excelError.map((item) => (
                        <p className="text-red-900 text-[12px]">{item}</p>
                      ))}
                  </div>
                  <div className="text-blue-700 w-full flex flex-col gap-4 !text-xs cursor-pointer">
                    <div
                      onClick={exportToExcel}
                      loading={isLoading === null ? true : false}
                      className="w-full flex hover:underline hover:underline-offset-1"
                    >
                      <AttachFileRoundedIcon className="w-1 h-1" />
                      <Typography variant="small">SamplePeopleList</Typography>
                    </div>
                    <div
                      onClick={exportToExcelDepartment}
                      className="w-full flex hover:underline hover:underline-offset-1"
                    >
                      <AttachFileRoundedIcon className="w-1 h-1" />
                      <Typography variant="small">DepartmentList</Typography>
                    </div>
                  </div>
                </CardBody>
                <CardFooter className="flex justify-end border-t-2 py-2 gap-4">
                  <Button
                    variant="text"
                    color="red"
                    onClick={handleOpenUploadDialog}
                  >
                    <span>Cancel</span>
                  </Button>
                  {isLoadingButtonForExcel ? (
                    <LoadingButton isSetText={true} isLoading={isLoading} />
                  ) : (
                    <Button variant="gradient" type="submit" color="green">
                      <span>Submit Excel</span>
                    </Button>
                  )}
                </CardFooter>
              </>
            ) : (
              <>
                <CardBody className="overflow-y-auto flex flex-col gap-4 max-h-[calc(100vh-150px)]">
                  <Typography variant="h4" color="blue-gray">
                    Upload Error
                  </Typography>
                  <table className="mt-1 w-full min-w-max table-auto text-left">
                    <thead>
                      <tr>
                        {["People Name", "Error"].map((head) => (
                          <th
                            key={head}
                            className="cursor-pointer border-y border-red-50 bg-red-50/50 p-2 transition-colors hover:bg-red-50 w-32"
                          >
                            <Typography
                              variant="small"
                              color="black"
                              className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                            >
                              {head}
                            </Typography>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {excelLogEnteries &&
                        excelLogEnteries.length > 0 &&
                        excelLogEnteries.map((item, index) => {
                          const [vendor1, questionnaire1] = item.split(",");
                          const vendor = vendor1.split(":");
                          const questionnaire = questionnaire1.split(":");
                          const isLast = index === excelLogEnteries.length - 1;
                          const classes = isLast
                            ? "p-2.5"
                            : "p-2.5 border-b border-red-100";
                          return (
                            <tr key={index}>
                              <td className={classes}>
                                <Typography
                                  variant="small"
                                  color="red"
                                  className="font-normal"
                                >
                                  {vendor[1]}
                                </Typography>
                              </td>
                              <td className={classes}>
                                <Typography
                                  variant="small"
                                  color="red"
                                  className="font-normal"
                                >
                                  {questionnaire[1]}
                                </Typography>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </CardBody>
                <div className="py-2 bg-red-100 bg-opacity-80 rounded-md p-3">
                  <Typography
                    variant="small"
                    color="red"
                    className="font-normal text-sm"
                  >
                    <span className="font-bold">
                      <sup>*</sup>Error:
                    </span>
                    <span>
                      {" "}
                      Questionnaire not found or spelling error or people is
                      already exist.
                    </span>
                  </Typography>
                </div>
                <CardFooter className="flex justify-end border-t-2 py-2">
                  <Button
                    variant="text"
                    color="red"
                    onClick={handleOpenUploadDialog}
                  >
                    <span>Cancel</span>
                  </Button>
                </CardFooter>
              </>
            )}
          </Card>
          <Card className="mx-auto w-full p-2"></Card>
        </form>
      </Dialog>
    </div>
  );
}
